import * as React from 'react';
import { Component } from 'react';
import * as PropTypes from 'prop-types';

import { formatCurrencyAmount } from '../../utils/formatUtils';

export interface IPriceLabelProps {
    className: string;
    price: number;
    hasError: boolean;
    dealerPhone: string;
    vppMonthlyPaymentLabeled: string;
    isVppMonthlyPaymentEnabled: boolean;
    isCashOffer?: boolean;
    offerType?: string;
    isMenuPaymentsDisclaimerEnabled?: boolean;
}

export interface IPriceLabelState {
}

export class PriceLabelUI extends Component<IPriceLabelProps, IPriceLabelState> {
    static propTypes = {
        className: PropTypes.string,
        price: PropTypes.number,
        hasError: PropTypes.bool,
        dealerPhone: PropTypes.string,
        offerType: PropTypes.string,
        isMenuPaymentsDisclaimerEnabled: PropTypes.bool
    };

    constructor(props: IPriceLabelProps) {
        super(props);
    }

    componentDidMount() {
    }

    render() {
        const {
            price,
            className,
            dealerPhone,
            hasError,
            isCashOffer,
            vppMonthlyPaymentLabeled,
            offerType,
            isMenuPaymentsDisclaimerEnabled,
            isVppMonthlyPaymentEnabled } = this.props;
        const classNames = `dr-ui-price-label ${className}`;
        const priceToDisplay = !price ? null : formatCurrencyAmount(price);
        if (hasError) {
            return (
                <div className={classNames}>
                    <div>
                        Call for Pricing
                    </div>
                    <div className="phone-number">
                        <a href={`tel:${dealerPhone}`}><i className="dr-ui-icon fa fa-phone"></i></a>
                        <a href={`tel:${dealerPhone}`}>{dealerPhone}</a>
                    </div>
                </div>
            );
        }

        const priceDiscloser = price => (<p>Total price {price} plus<br /> taxes and interest </p>);

        return (
            <div className={classNames}>
                {isVppMonthlyPaymentEnabled && !isCashOffer && (
                    <div>
                        <div className="est-payment">
                            Est. Payment
                            {this.props.isMenuPaymentsDisclaimerEnabled
                                ? (
                                    <span className="disclaimer">
                                        based on {this.props.offerType === 'finance' ? 'loan' : 'lease'} term
                                    </span>
                                )
                                : null}
                        </div>

                        <div className="dr-ui-price-label-total">
                            {vppMonthlyPaymentLabeled}
                        </div>

                        <div className="dr-ui-price-total-desc">
                            {price ? priceDiscloser(priceToDisplay) : ''}
                        </div>
                    </div>
                )}

                {!isVppMonthlyPaymentEnabled || (isVppMonthlyPaymentEnabled && isCashOffer) && (
                    <div>
                        <div className="dr-ui-price-label-header">Price</div>
                        <div className="dr-ui-price-label-total">
                            {priceToDisplay}
                        </div>
                        <div>
                            {this.props.price ? 'plus taxes and interest' : ''}
                        </div>
                    </div>
                )}

            </div>
        );
    }
}
